module.exports = __webpack_public_path__ + "img/profile-card.6b31a2df.svg";